module.exports = __webpack_public_path__ + "s-011944b13659b41bb0a0b24ec3d381f1.png";